import { Component,Input } from '@angular/core';
import { OrdersCoServices } from '../../pages/orders/services';

/**
 * Generated class for the TpvKeyboardExportableComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'orders-keyboard-exportable',
  templateUrl: 'orders-keyboard-exportable.html'
})
export class OrdersKeyboardExportableComponent {
    @Input() screen_show: boolean = true;


  constructor(public ordersCoServices: OrdersCoServices) {
  }

}



// WEBPACK FOOTER //
// ./src/components/orders-keyboard-exportable/orders-keyboard-exportable.ts